import type { Webmaster } from 'types';

import { useMemo } from 'react';
import Head from 'next/head';

const VerificationMeta: React.FC<Webmaster> = props => {
  const metaValues = useMemo(() => {
    return [
      { name: 'baidu-site-verification', content: props?.baiduVerification },
      { name: 'msvalidate.01', content: props?.bingVerification },
      {
        name: 'google-site-verification',
        content: props?.googleVerification,
      },
      {
        name: 'p:domain_verify',
        content: props?.pinterestVerification,
      },
      { name: 'yandex-verification', content: props?.yandexVerification },
    ];
  }, [props]);

  return (
    <>
      {metaValues.map(
        ({ name, content }) =>
          content && <meta name={name} content={content} key={name} />,
      )}
    </>
  );
};

const AppHead: React.FC<{ webmasterMeta?: Webmaster }> = ({
  webmasterMeta,
}) => {
  return (
    <Head>
      {webmasterMeta && <VerificationMeta {...webmasterMeta} />}
      <meta httpEquiv="x-ua-compatible" content="ie=edge" key="httpequiv" />
      <meta
        name="viewport"
        content="width=device-width, viewport-fit=cover, initial-scale=1.0, maximum-scale=3.0"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/favicon/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon/favicon-16x16.png"
      />
      <link rel="manifest" href="/favicon/site.webmanifest" />
      <link
        rel="mask-icon"
        href="/favicon/safari-pinned-tab.svg"
        color="#36DC90"
      />
      <link rel="shortcut icon" href="/favicon/favicon.ico" />
      <meta name="theme-color" content="#ffffff" key="theme-color" />
    </Head>
  );
};

export default AppHead;
